<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'bulletpoints-block section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <h2 v-if="!block.hide_title && block.images.length > 0" :class="['title', block.title_colour]">{{block.title}}</h2>
        <div class="columns is-variable is-6">
            <div class="column is-4">
                <template v-if="block.images.length > 0">
                    <figure v-for="image in block.images">
                        <img :src="image.url" :alt="image.title" />
                    </figure>
                </template>
                <h2 v-else :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <div ref="content_top" class="content" v-if="block.content.top" v-html="block.content.top"></div>
                <div class="content" v-if="block.bulletpoints && block.bulletpoints.length > 0">
                    <ul class="bulletpoints">
                        <ExpandableLi :bullet="bullet" :colour="block.title_colour.replace(/colour\-/gi, 'bg-')" :key="i" v-for="bullet, i in block.bulletpoints" />
                    </ul>
                </div>
                <div ref="content_bottom" class="content" v-if="block.content.bottom" v-html="block.content.bottom"></div>
                <div class="cta" v-if="block.cta && block.cta.button">
                    <CTALink :link_data="block.cta" />
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import ExpandableLi from './elements/ExpandableLi';
export default {
    name        :   'AdvancedImageContentBlock',
    mixins      :   [ BlockCommons ],
    components  :   { ExpandableLi },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content_top) {
                this.HandleContentedLinks(this.$refs.content_top, this)
            }

            if (this.$refs.content_bottom) {
                this.HandleContentedLinks(this.$refs.content_bottom, this)
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.cta {
    padding-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/AdvancedImageContentBlock.vue